import { styling } from '../core/styling.js';
import { px } from '../core/px.js';

const maxWidth = styling({
    $maxWidth: {
        type: 'string | number',
        properties: ['maxWidth'],
        transform: px,
    },
});

export { maxWidth };
//# sourceMappingURL=maxWidth.js.map
